import { render } from "./NcFormField.vue?vue&type=template&id=5813dbe9&scoped=true"
import script from "./NcFormField.vue?vue&type=script&lang=js"
export * from "./NcFormField.vue?vue&type=script&lang=js"

import "./NcFormField.vue?vue&type=style&index=0&id=5813dbe9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5813dbe9"]])

export default __exports__